import axios from '../API/axios';

export const getUnavailableDates = (country: string) => {
  return axios.get(`unavailable-dates/${country}`);
};
